import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";
import { useNavigate } from "react-router-dom";

import { useTestAuthApi } from "@/lib/queries/use-test-auth-api";

export function Home() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const testApiMutation = useTestAuthApi();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-muted">
      <section className="container mx-auto px-6 py-20">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight leading-tight">
            Minimal login and admin preview
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            A crisp starter with authentication and a protected admin screen. Clean, fast, and easy
            to extend.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            {isAuthenticated ? (
              <Button onClick={() => navigate("/admin")}>Open Admin</Button>
            ) : (
              <Button onClick={() => navigate("/login")}>Sign in</Button>
            )}
            <Button
              variant="outline"
              onClick={() => testApiMutation.mutate()}
              disabled={testApiMutation.isPending}
            >
              {testApiMutation.isPending ? "Testing..." : "Test Auth API"}
            </Button>
          </div>
        </div>
      </section>

      <section className="container mx-auto px-6 pb-24">
        <Card className="max-w-3xl">
          <CardHeader>
            <CardTitle>Authenticated API</CardTitle>
            <CardDescription>Quickly verify your session with a sample request.</CardDescription>
          </CardHeader>
          <CardContent>
            {!isAuthenticated && (
              <p className="text-sm text-muted-foreground mb-3">You’ll need to sign in first.</p>
            )}
            {testApiMutation.data && (
              <pre className="text-sm overflow-auto rounded-md bg-muted p-4">
                {JSON.stringify(testApiMutation.data, null, 2)}
              </pre>
            )}
            {testApiMutation.error && (
              <div className="rounded-md bg-red-50 text-red-700 p-4 text-sm">
                {testApiMutation.error.message}
              </div>
            )}
          </CardContent>
        </Card>
      </section>
    </div>
  );
}
